namespace GeniuzPOS.Purchase {
    export interface ReportDailyCNDetailData extends Serenity.ListRequest {
        para?: string;
        Shop?: string;
        DatetoDate?: string;
        Supdata?: string;
        ListHd?: ReportDailyCNRow[];
        Details?: PoCreditNoteDtRow[];
    }
}
